<select #oparaDiscovery class="form-control w-100 mt-2 btn-lg text-truncate" (change)="checkInstitutionSelection($event)">
  <option value="" selected>{{ "login.form.institution.select" | translate }}</option>
  <option value="{{institution.key}}" *ngFor="let institution of allInstitutions | keyvalue ">{{institution.value.label}}</option>
</select>
<button class="btn btn-lg btn-primary btn-block mt-2 text-white" (click)="redirectToExternalProvider()" [disabled]="!buttonEnabled">
  <i class="fas fa-sign-in-alt"></i> {{getButtonLabel() | translate}}
</button>
